import React, { Component } from 'react';
import styles from './ButtonReset.module.css';
import ButtonX from '../components/ButtonX';
import ButtonAlt from '../components/ButtonAlt';
import * as constants from '../constants';

class ButtonReset extends Component {

    state = {
        confirm: false
    }

    showConfirm = () => {
        this.setState({ confirm: true });
    }

    hideConfirm = () => {
        this.setState({ confirm: false });
    }

    render() {

        let confirm = null;
        if (this.state.confirm) {
            confirm = (
                <div className={styles.modal}>
                    <div className={styles.buffer}></div>
                    <div className={styles.confirmDialog}>
                        <div className={styles.newGameText}>
                            {constants.TEXT17}
                        </div>
                        <div className={styles.buttons}>
                            <ButtonAlt onClick={this.props.resetGame}>{constants.TEXT18}</ButtonAlt>
                            <ButtonAlt onClick={this.hideConfirm}>{constants.TEXT19}</ButtonAlt>
                        </div>
                    </div>
                </div >
            );
        }

        return (
            <>
                <ButtonX color='white' onClick={this.showConfirm} />
                {confirm}
            </>
        );
    }
}

export default ButtonReset;